
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/singles/[gameSlug]",
      function () {
        return require("private-next-pages/singles/[gameSlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/singles/[gameSlug]"])
      });
    }
  